'use strict';
module.exports = function css(domElement, styles) {
	Object.keys(styles).forEach(key => {
		domElement.style[key] = styles[key];
	});
};
